import rikamiScreen from "../imgs/screen_rikami.png";
import fitbudScreen from "../imgs/screen_fitbud.png";

// Mock data for molelabs portfolio

export const projects = [
	{
		id: "1",
		title: "Rikami",
		description:
			"E-commerce con gestione prodotti e ordini per una startup del mondo della moda",
		descriptionEn:
			"E-commerce with product and order management for a fashion startup",
		technologies: ["React", "Node.js", "MongoDB"],
		image: rikamiScreen,
		liveUrl: "https://www.rikami.it/",
		category: "Full-Stack",
	},
	{
		id: "2",
		title: "BudAI",
		description:
			"Chatbot avanzato con integrazione LLM per assistenza clienti 24/7",
		descriptionEn:
			"Advanced chatbot with LLM integration for 24/7 customer support",
		technologies: ["Python", "FastAPI", "OpenAI", "React"],
		image:
			"https://ddi-dev.com/uploads/media/news/0001/02/584668831a98d094bf9ceb0a533d0984149e044f.jpeg",
		liveUrl: "#",
		category: "AI",
	},
	{
		id: "3",
		title: "Trattoria In",
		description:
			"Sito web con sistema di prenotazioni per una trattoria italiana",
		descriptionEn: "Italian restaurant website with booking system",
		technologies: ["Next.js", "MongoDB", "FastAPI"],
		image:
			"https://www.vinhood.com/wp-content/uploads/2020/09/Locanda-Carretta-in-Cannubi.jpg",
		liveUrl: "#",
		category: "Full-Stack",
	},
	{
		id: "4",
		title: "EcoCommerce",
		description:
			"Piattaforma e-commerce sostenibile con sistema di raccomandazione AI",
		descriptionEn:
			"Sustainable e-commerce platform with AI recommendation system",
		technologies: ["React", "Express", "Stripe", "MongoDB"],
		image:
			"https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=800&h=600&fit=crop",
		liveUrl: "#",
		category: "Full-Stack",
	},
	{
		id: "5",
		title: "FinanziariaMente",
		description:
			"Piattaforma web per aiuto finanziario personalizzato con chatbot e AI",
		descriptionEn:
			"Web platform for personalized financial advice with chatbot and AI",
		technologies: ["Python", "MongoDB", "React", "OpenAI"],
		image:
			"https://images.unsplash.com/photo-1618044733300-9472054094ee?w=800&h=600&fit=crop",
		liveUrl: "#",
		category: "Full-Stack",
	},
	{
		id: "6",
		title: "FitBud",
		description: "Applicazione full-stack per monitoraggio salute e fitness",
		descriptionEn: "Full-stack health and fitness tracking application",
		technologies: ["React Native", "Node.js", "MongoDB", "AWS"],
		image: fitbudScreen,
		liveUrl: "https://fitbud-one.vercel.app/",
		category: "Full-Stack",
	},
];

export const services = [
	{
		id: "1",
		title: "Siti e Applicazioni Web",
		titleEn: "Websites and Web Apps",
		description:
			"Realizziamo siti web moderni, veloci e facili da usare, con aree riservate e database quando servono.",
		descriptionEn:
			"We build modern, fast, easy-to-use websites, with member areas and databases when needed.",
		icon: "code",
	},
	{
		id: "2",
		title: "Chatbot e Assistenti",
		titleEn: "Chatbots and Assistants",
		description:
			"Creiamo assistenti automatici chiari e utili per rispondere ai clienti, anche fuori orario.",
		descriptionEn:
			"We build helpful assistants that answer customer questions, even outside office hours.",
		icon: "bot",
	},
	{
		id: "3",
		title: "AI nelle Tue App",
		titleEn: "AI in Your Apps",
		description:
			"Aggiungiamo funzioni intelligenti ai tuoi siti, come risposte automatiche, suggerimenti e ricerca veloce di informazioni.",
		descriptionEn:
			"We add smart features to your websites, like automatic replies, suggestions, and quick search.",
		icon: "brain",
	},
	{
		id: "4",
		title: "Sistema di prenotazioni",
		titleEn: "Booking System",
		description:
			"Creiamo sistemi di prenotazione semplici per appuntamenti, tavoli, servizi o eventi.",
		descriptionEn:
			"We create simple booking systems for appointments, tables, services, or events.",
		icon: "calendar",
	},
	{
		id: "5",
		title: "Ricerca nei Documenti",
		titleEn: "Document Search",
		description:
			"Organizziamo i tuoi documenti per trovare risposte in pochi secondi con una semplice domanda.",
		descriptionEn:
			"We organize your documents so you can find answers in seconds with a simple question.",
		icon: "database",
	},
	{
		id: "6",
		title: "Gestione e Supporto",
		titleEn: "Management and Support",
		description:
			"Ci occupiamo di aggiornamenti, sicurezza e manutenzione continua, cosi il tuo sito resta sempre online e affidabile.",
		descriptionEn:
			"We handle updates, security, and ongoing maintenance, so your website stays online and reliable.",
		icon: "server",
	},
];

export const translations = {
	it: {
		nav: {
			home: "Home",
			portfolio: "Portfolio",
			services: "Servizi",
			about: "Chi Siamo",
			contact: "Contatti",
		},
		hero: {
			headline: "Trasformiamo idee in",
			headlineAccent: "soluzioni digitali intelligenti",
			subtitle:
				"Studio digitale che crea siti web e strumenti intelligenti per far crescere il tuo business.",
			cta1: "Scopri i progetti",
			cta2: "Contattaci",
		},
		services: {
			title: "I Nostri Servizi",
			subtitle:
				"Servizi semplici e concreti per migliorare il tuo lavoro con il digitale",
		},
		portfolio: {
			title: "Progetti Realizzati",
			subtitle: "Una selezione dei nostri lavori migliori",
			all: "Tutti",
			ai: "AI",
			fullstack: "Full-Stack",
			viewProject: "Vedi Progetto",
			liveDemo: "Live Website",
		},
		about: {
			title: "Chi siamo",
			subtitle: "",
			description:
				"In molelabs siamo un team con anni di esperienza maturata in grandi multinazionali, dove abbiamo progettato e realizzato siti web, aree riservate e strumenti digitali su larga scala.\n\nOggi mettiamo quella competenza al servizio di realta che vogliono costruire prodotti digitali solidi, scalabili e realmente utili.\n\nSiamo appassionati di tecnologia, ma ancora di piu di soluzioni fatte bene. Lavoriamo a stretto contatto con ogni cliente, trasformando idee in prodotti concreti, con un unico obiettivo: raggiungere la massima qualita e soddisfazione in ogni progetto.",
			mission: "La Nostra Mission",
			missionText:
				"Creare soluzioni digitali che risolvono problemi reali, automatizzano processi complessi e generano valore misurabile per i nostri clienti.",
			approach: "Il Nostro Approccio",
			approachText:
				"Lavoriamo a stretto contatto con i clienti, comprendendo le loro esigenze e traducendole in soluzioni tecniche efficaci e scalabili.",
		},
		contact: {
			title: "Parliamone",
			subtitle: "Hai un progetto in mente? Raccontaci la tua idea",
			name: "Nome",
			email: "Email",
			message: "Messaggio",
			send: "Invia Messaggio",
			sending: "Invio in corso...",
			success: "Messaggio inviato con successo! Ti risponderemo presto.",
			error: "Errore nell'invio del messaggio. Riprova.",
		},
		footer: {
			rights: "© 2025 molelabs. Tutti i diritti riservati.",
			tagline: "Innovazione tech per il futuro digitale",
		},
	},
	en: {
		nav: {
			home: "Home",
			portfolio: "Portfolio",
			services: "Services",
			about: "About",
			contact: "Contact",
		},
		hero: {
			headline: "We transform ideas into",
			headlineAccent: "intelligent digital solutions",
			subtitle:
				"Digital studio building websites and smart tools to help your business grow.",
			cta1: "View Projects",
			cta2: "Get in Touch",
		},
		services: {
			title: "Our Services",
			subtitle:
				"Simple, practical services to improve your business with digital tools",
		},
		portfolio: {
			title: "Our Work",
			subtitle: "A selection of our best projects",
			all: "All",
			ai: "AI",
			fullstack: "Full-Stack",
			viewProject: "View Project",
			liveDemo: "Live Website",
		},
		about: {
			title: "About Us",
			subtitle: "Innovation and Expertise",
			description:
				"molelabs is a digital studio building websites, database-backed tools, and smart assistants. Our approach combines technical expertise, creativity and a results-focused mindset.",
			mission: "Our Mission",
			missionText:
				"Creating digital solutions that solve real problems, automate complex processes and generate measurable value for our clients.",
			approach: "Our Approach",
			approachText:
				"We work closely with clients, understanding their needs and translating them into effective and scalable technical solutions.",
		},
		contact: {
			title: "Let's Talk",
			subtitle: "Have a project in mind? Tell us about your idea",
			name: "Name",
			email: "Email",
			message: "Message",
			send: "Send Message",
			sending: "Sending...",
			success: "Message sent successfully! We'll get back to you soon.",
			error: "Error sending message. Please try again.",
		},
		footer: {
			rights: "© 2025 molelabs. All rights reserved.",
			tagline: "Digital innovation for the digital future",
		},
	},
};
